import React from "react";
import InfoTiles from "./InfoTiles";
import KosherPlacesGrid from "./KosherPlacesGrid";
import HotelsGrid from "./HotelsGrid";
import HotelsList from "./HotelsList";
import AttractionsGrid from "./AttractionsGrid";
import Services from "./Services";
import Banners from "./Banners";
import EventsStrip from "./EventsStrip";
import ArticlesStrip from "./ArticlesStrip";
import JourneyCTA from "./JourneyCTA";
import AiContentSlot from "../../../components/AiContentSlot";
import logger from "../../../services/logger"

// Registry des composants UI réutilisables du thème Travel.
// Clé (id) = nom stable utilisé pour appeler un composant par string.
// Tous les composants ont la même signature : ({ context }) => ReactNode.
// Ajouter ici tout nouveau composant pour qu'il soit accessible via renderUIComponent()
// ou <UIComponent id="..." context={...} />.
export const UI_COMPONENTS = {
    InfoTiles,
    KosherPlacesGrid,
    HotelsGrid,
    HotelsList,
    AttractionsGrid,
    Services,
    Banners,
    EventsStrip,
    ArticlesStrip,
    JourneyCTA,
    AiContentSlot,
};

/**
 * Rend un composant UI par son id avec le context partagé du thème.
 * Retourne null si l'id est inconnu — évite de crasher si la config
 * référence un composant qui n'existe pas (encore).
 *
 * @example
 *   renderUIComponent("KosherPlacesGrid", context)
 */
export function renderUIComponent(id, context, key) {
    const Comp = UI_COMPONENTS[id];
    if (!Comp) {
        logger.warn({ id }, `[ui-components] Unknown component id: "${id}"`);
        return null;
    }
    return <Comp key={key} context={context} />;
}

/**
 * Version JSX : <UIComponent id="KosherPlacesGrid" context={context} />.
 * Pratique dans une liste de composants configurée en data (ex: page d'accueil
 * dont la composition est stockée en base).
 */
export function UIComponent({ id, context }) {
    return renderUIComponent(id, context);
}

export { InfoTiles, KosherPlacesGrid, HotelsGrid, HotelsList, AttractionsGrid, Services, Banners, EventsStrip, ArticlesStrip, JourneyCTA, AiContentSlot };
